// extracted by mini-css-extract-plugin
export default {"container":"WordGameLayout_container__7vvfW","sub_container":"WordGameLayout_sub_container__z1Aw2"};